export default "__VITE_ASSET__C3w7n2H0__"